import React from 'react';
import { visualTypes, audiences } from '../data/content';
export function VisualTypesSection() {
  return <section className="w-full bg-night-deep px-5 py-12" aria-labelledby="visuales-titulo" data-id="element-212" data-mp="1loiat65i0y1p">
      <div className="mx-auto max-w-5xl" data-id="element-213" data-mp="1hmdh67f1w1f2">
        <h2 id="visuales-titulo" className="text-center font-display text-2xl font-bold leading-snug text-gold md:text-4xl" data-id="element-214" data-mp="1hnerg9o8sjvq">
          Distintos tipos de <span className="text-cream" data-id="element-215" data-mp="29d1gddx5ywq3">contenido visual</span>
        </h2>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-216" data-mp="25c7usr771u0d">
          {visualTypes.map(visual => <figure key={visual.src} className="flex h-full flex-col overflow-hidden rounded-xl border border-night-line bg-night-card" data-id="element-217" data-mp="20clg0dbpw5pg">
              <img src={visual.src} alt={visual.caption} className="w-full" loading="lazy" data-id="element-218" data-mp="oz0u7w4z9rl8" />
              <figcaption className="mt-auto px-4 py-3 text-sm text-cream-dim" data-id="element-219" data-mp="jzoa3j5hqymc">{visual.caption}</figcaption>
            </figure>)}
        </div>

        <div className="mt-16 text-center" data-id="element-220" data-mp="1fc707n6nxedl">
          <h3 className="font-display text-lg font-bold text-cream md:text-xl" data-id="element-221" data-mp="1jdiuw74e8psn">
            La eligen cristianos de todas las denominaciones
          </h3>
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-3" data-id="element-222" data-mp="15czr5c6yo5wa">
            {audiences.map(audience => <li key={audience.label} className="rounded-full border border-night-line bg-night-soft px-5 py-2 text-sm text-cream" data-id="element-223" data-mp="vng7i4bfc80d">
                <span aria-hidden="true" data-id="element-224" data-mp="10g9aonr8v8ac">{audience.emoji}</span> {audience.label}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}